import { render, staticRenderFns } from "./FieldWorkplace2Write.vue?vue&type=template&id=8e4905f4&scoped=true&"
import script from "./FieldWorkplace2Write.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2Write.vue?vue&type=script&lang=js&"
import style0 from "./FieldWorkplace2Write.vue?vue&type=style&index=0&id=8e4905f4&prod&scoped=true&lang=scss&"
import style1 from "./FieldWorkplace2Write.vue?vue&type=style&index=1&id=8e4905f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4905f4",
  null
  
)

export default component.exports